webpackJsonp([6],{

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $('body');

	var $elements = $container.find('[data-animate]');
	var $elementsResponsive = $elements.filter(function (index, element) {
		return $(element).data('animate-responsive');
	});
	var $elementsNotResponsive = $elements.filter(function (index, element) {
		return !$(element).data('animate-responsive');
	});
	var responsiveWidth = 768;

	if ($elementsNotResponsive.length && $(window).width() > responsiveWidth) {
		setAnimation($elementsNotResponsive);
	} else {
		removeAnimation($elementsNotResponsive);
	}

	if ($elementsResponsive.length) {
		setAnimation($elementsResponsive);
	}
};

var _IO = __webpack_require__(58);

var _IO2 = _interopRequireDefault(_IO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setAnimation($containers) {
	var animateIO = new _IO2.default();
	animateIO.setBefore(function (container, observer) {
		var $container = $(container);
		var innerElements = $container.find('[data-animate-element]');
		var $elements = innerElements.length ? innerElements : $container;
		var delay = $container.data('animate-delay');

		if (!$container.data('is-init')) {
			$elements.each(function (i, el) {
				var $element = $(this);
				if (i > 0 && delay) {
					$element.addClass('_animate-delay-' + i);
				}
				$element.addClass('animated');
			});

			$container.data({
				'is-animated': false,
				'is-init': true
			});

			observer.observe(container);
		}
	});
	animateIO.setCallback(function (entry) {
		var $container = $(entry.target);
		var innerElements = $container.find('[data-animate-element]');
		var $elements = innerElements.length ? innerElements : $container;
		var alias = $container.data('animate');
		var isRepeat = !!$container.data('animate-repeat');

		if (!isRepeat) {
			if (entry.isIntersecting && !$container.data('is-animated')) {
				$elements.each(function (i, el) {
					var $element = $(this);
					$element.addClass(alias);
				});
				$container.data('is-animated', true);
			}
		} else {
			if (entry.isIntersecting) {
				$elements.each(function (i, el) {
					var $element = $(this);
					$element.addClass(alias);
				});
				$container.data('is-animated', true);
			} else {
				$elements.each(function (i, el) {
					var $element = $(this);
					$element.removeClass(alias);
				});
				$container.data('is-animated', false);
			}
		}
	});
	animateIO.observe($containers);
}

function removeAnimation($containers) {
	$containers.each(function (index, container) {
		var $container = $(container);
		var innerElements = $container.find('[data-animate-element]');
		var $elements = innerElements.length ? innerElements : $container;
		var alias = $container.data('animate');

		$elements.each(function (i, el) {
			var $element = $(el);
			$element.removeClass('animated');
			$element.removeClass(alias);
		});
	});
}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.trigger = undefined;

var _jsCookie = __webpack_require__(0);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _validation = __webpack_require__(15);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

var triggerBuffer = [];
var popupOpen = false;

function showPopup() {
	$.ajax({
		url: '/popup/autoform',
		type: 'post',
		data: {
			id: triggerBuffer.shift()
		},
		success: function success(response) {
			if (response) {
				var $html = $(response);
				$.magnificPopup.open({
					items: {
						src: $html
					},
					type: 'inline',
					removalDelay: 300,
					mainClass: 'zoom-in',
					closeBtnInside: true,
					autoFocusLast: false,
					fixedContentPos: false,
					callbacks: {
						open: function open() {
							(0, _validation2.default)('.js-form', $html);
						},
						afterClose: function afterClose() {
							if (triggerBuffer.length) {
								setTimeout(function () {
									showPopup();
								}, 1000);
							} else {
								popupOpen = false;
							}
						}
					}
				});
			}
		}
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

function trigger() {
	$('.js-trigger').each(function () {
		var el = this;
		var $el = $(el);
		var id = this.id;

		if (id) {
			var observer = void 0;
			if (window.IntersectionObserver) {
				observer = new window.IntersectionObserver(function (entries) {
					if (entries[0].isIntersecting && !$el.data('trigger')) {
						$el.data('trigger', true);
						triggerBuffer.push(id);
						if (!popupOpen && triggerBuffer.length) {
							popupOpen = true;
							showPopup();
						}
					}
				}, {
					rootMargin: '0px',
					threshold: 0
				});
				observer.observe(el);
			} else {
				triggerBuffer.push(id);
				if (!popupOpen && triggerBuffer.length) {
					popupOpen = true;
					showPopup();
				}
			}
		}
	});

	$('.js-trigger-click').each(function () {
		var el = this;
		var $this = $(el);
		var timeout = $this.data('timeout');
		var cookie = $this.data('cookie');
		var isObserver = $this.data('observer');
		var ns = $this.data('ns');

		var showTimeout = function showTimeout(func) {
			if (timeout) {
				setTimeout(function () {
					func();
				}, timeout);
			} else {
				func();
			}
		};

		var showObserver = function showObserver(func) {
			if (isObserver && window.IntersectionObserver) {
				var observer = new window.IntersectionObserver(function (entries) {
					if (entries[0].isIntersecting && !$this.data('is-observed')) {
						$this.data('is-observed', true);
						func();
					}
				}, {
					rootMargin: '0px',
					threshold: 0
				});
				observer.observe(el);
			} else {
				func();
			}
		};

		var showCookie = function showCookie(func) {
			if (cookie) {
				if (!_jsCookie2.default.get(cookie)) {
					func();
				}
			} else {
				func();
			}
		};

		var showNs = function showNs(func) {
			if (ns) {
				if (!$('[data-ns="' + ns + '"].js-trigger-click.is-triggered').length) {
					func();
				}
			} else {
				func();
			}
		};

		if (!$.magnificPopup.instance.isOpen) {
			showCookie(function () {
				showObserver(function () {
					showTimeout(function () {
						showNs(function () {
							$this.addClass('is-triggered');
							$this.trigger('click');
						});
					});
				});
			});
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.trigger = trigger;

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	var container = document.querySelector('[data-scroll-container]');
	if (container) {
		var locoScroll = new _locomotiveScroll2.default({
			el: container,
			smooth: true
		});

		locoScroll.on('scroll', function (obj) {
			showNavpanel(obj);
			showScrollTopButton(obj);
			lazyLoad(obj);
		});

		locoScroll.scrollTo(1);

		$('.js-top').removeClass('is-visible').on('click', function () {
			locoScroll.scrollTo('top');
		});
	}
};

var _locomotiveScroll = __webpack_require__(148);

var _locomotiveScroll2 = _interopRequireDefault(_locomotiveScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previousTop = 0;
var scrollDelta = 5;
var scrollOffset = 50;
var $selector = $('.js-navpanel');
var $body = $('body');

function showNavpanel(obj) {
	var currentTop = obj.scroll.y;
	if (previousTop - currentTop > scrollDelta) {
		$body.addClass('show-header');
	} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
		$body.addClass('show-w');
		$body.removeClass('show-header');
	}
	if (currentTop < scrollOffset) {
		$body.removeClass('show-header show-w');
	}
	previousTop = currentTop;
}

function showScrollTopButton(obj) {
	if (obj.scroll.y > 100) {
		$('.js-top').addClass('is-visible');
	} else {
		$('.js-top').removeClass('is-visible');
	}
}

function lazyLoad(obj) {
	for (var key in obj.currentElements) {
		var el = obj.currentElements[key].target || obj.currentElements[key].targetEl;
		var progress = obj.currentElements[key].progress;
		var lazy = el.getAttribute('data-scroll-lazy');

		if (lazy) {
			if (!el.classList.contains('is-load')) {
				var src = el.getAttribute('data-src');
				if (lazy === 'image' || lazy === 'video') {
					el.setAttribute('src', src);
				} else if (lazy === 'bg') {
					el.style.backgroundImage = 'url(' + src + ')';
				} else if (lazy === 'sticky') {
					var sticky = el.querySelector('[data-scroll-sticky]');
					if (sticky) {
						sticky.style.backgroundImage = 'url(' + src + ')';
					}
				}
				el.classList.add('is-load');
			}

			if (lazy === 'video' && el.getAttribute('data-scroll-autoplay')) {
				if (progress < 0.2 || progress > 0.8) {
					el.pause();
				} else {
					el.play();
				}
			}
		}
	}
}

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lightgallery = __webpack_require__(150);

var _lightgallery2 = _interopRequireDefault(_lightgallery);

var _thumbnail = __webpack_require__(151);

var _thumbnail2 = _interopRequireDefault(_thumbnail);

var _zoom = __webpack_require__(152);

var _zoom2 = _interopRequireDefault(_zoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function galleryInit() {
	var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $('body');

	$container.find('[data-gallery]').each(function () {
		(0, _lightgallery2.default)(this, {
			plugins: [_zoom2.default, _thumbnail2.default],
			selector: '[data-gallery-element]',
			download: false,
			share: false,
			rotate: false,
			autoplayControls: false,
			hash: false,
			exThumbImage: 'data-thumb'
		});
	});
}

exports.default = galleryInit;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит валидации форм
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(14);

__webpack_require__(20);

__webpack_require__(70);

__webpack_require__(71);

__webpack_require__(72);

__webpack_require__(0);

var _preloader = __webpack_require__(73);

var _preloader2 = _interopRequireDefault(_preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cookies = __webpack_require__(0);

// ----------------------------------------
// Private
// ----------------------------------------

// import phoneMask from './phone-mask';
function formJsChangeFile($element, $form) {
	$form.data('validator').element($element);

	var $block = $element.closest('.custom-file');
	var $inputResult = $block.find('.custom-file__result');

	var fileList = $element[0].files;
	var names = [];
	var sizes = 0;

	if (fileList.length) {
		$block.addClass('has-file');
	} else {
		$block.removeClass('has-file');
	}

	for (var i = 0; i < fileList.length; i++) {
		var file = fileList[i];
		names.push(file.name);
		sizes += file.size;
	}

	sizes = (sizes / 1024).toFixed(2);

	if (names.length > 1) {
		names = names.length;
	} else {
		names = names[0];
		if (!names) {
			$inputResult.changeMyText('default');
			return;
		}
		names = '<span class="_ellipsis" title="' + names + '">' + names + '</span>';
	}

	$inputResult.changeMyText('changed', [names, sizes]);
}

function customFile($form) {
	var $el = $form.find('.js-custom-file');

	$el.on('change', function () {
		formJsChangeFile($(this), $form);
	});

	$form.on('click', '.js-custom-file-clear', function (event) {
		event.stopPropagation();
		$el.val('');
		formJsChangeFile($el, $form);
	});
}

/**
 * old function to show popup
 */

function noty(message, type) {
	$.magnificPopup.close();
	setTimeout(function () {
		var src = void 0;

		if (type === 'thanks') {
			src = '<div class="magnific-popup magnific-popup--thanks">\n\t\t\t\t\t\t<div class="noty__message _mt-def _pt-md _mb-md _pb-ms">' + message + '</div>\n\t\t\t\t\t\t<div class="noty__message noty__message--wezom">BY <span>WEZOM</span></div>\n\t\t\t\t\t</div>';
		} else {
			src = '<div class="noty magnific-popup magnific-popup--noty">\n\t\t\t\t\t\t<div class="noty__image">\n\t\t\t\t\t\t\t<img src="/Media/assets/css/static/pic/noty--' + type + '.jpg" alt="">\n\t\t\t\t\t\t\t<div class="noty__icon">\n\t\t\t\t\t\t\t\t<svg>\n\t\t\t\t\t\t\t\t\t<use xlink:href="/Media/assets/images/sprites/icons.svg#' + type + '"></use>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="noty__message">' + message + '</div>\n\t\t\t\t\t\t<button class="button button--yellow js-mfp-close">\n\t\t\t\t\t\t\t<span class="button__text">Close</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>';
		}

		$.magnificPopup.open({
			items: {
				src: src,
				type: 'inline'
			},
			removalDelay: 200,
			mainClass: 'zoom-in',
			autoFocusLast: false,
			fixedContentPos: false
		});
	}, 250);
};

/**
 * Параметры по умолчанию
 * @const {Object}
 * @private
 */
var configDefault = {
	ignore: ':hidden, .js-ignore',
	errorClass: 'has-error',
	validClass: 'is-valid',
	get classes() {
		return {
			error: this.errorClass,
			valid: this.validClass,
			labelError: 'label-error',
			formError: 'form--error',
			formValid: 'form--valid',
			formPending: 'form--pending'
		};
	},

	onfocusout: function onfocusout(element) {
		this.element(element);
	},
	highlight: function highlight(element) {
		element.classList.remove(this.settings.classes.valid);
		element.classList.add(this.settings.classes.error);
	},
	unhighlight: function unhighlight(element) {
		element.classList.remove(this.settings.classes.error);
		element.classList.add(this.settings.classes.valid);
	},
	submitHandler: function submitHandler(form) {
		var $form = $(form);
		var actionUrl = $form.data('ajax');
		if (typeof actionUrl !== 'string') {
			window.alert(['Error!', '--------------------', 'ajax обработчик не указан'].join('\n'));
			return;
		}

		var preloader = new _preloader2.default($form.find('[type="submit"]'));
		preloader.show();

		var formData = new window.FormData();
		formData.append('xhr-lang', $('html').attr('lang') || 'ru');

		// игнорируемые типы инпутов
		var ignoredInputsType = ['submit', 'reset', 'button', 'image'];

		var token = void 0;

		$form.find('input, textarea, select').each(function (i, element) {
			var value = element.value,
			    type = element.type;

			if (~ignoredInputsType.indexOf(type)) {
				return true;
			}

			var $element = $(element);
			var elementNode = $element.nodeName();
			var elementName = $element.data('name') || $element.attr('name') || null;

			if (elementName === null) {
				return true;
			}

			if (elementName === 'token') {
				token = $element.val();
			}

			switch (elementNode) {
				case 'input':
					if (type === 'file' && element.files && element.files.length) {
						for (var _i = 0; _i < element.files.length; _i++) {
							var file = element.files[_i];
							formData.append(elementName, file);
						}
					} else {
						if ((type === 'checkbox' || type === 'radio') && !element.checked) {
							break;
						}
						if ($element.hasClass('js-phone-input')) {
							var code = $element.data('code');
							value = '+' + code + value;
						}
						formData.append(elementName, value);
					}
					break;

				case 'textarea':
					formData.append(elementName, value);
					break;

				case 'select':
					var multiName = /\[\]$/;
					if ((multiName.test(elementName) || element.multiple) && element.selectedOptions && element.selectedOptions.length) {
						elementName = elementName.replace(multiName, '');
						for (var _i2 = 0; _i2 < element.selectedOptions.length; _i2++) {
							var option = element.selectedOptions[_i2];
							if (option.disabled) {
								continue;
							}
							formData.append(elementName, option.value);
						}
					} else {
						formData.append(elementName, value);
					}
					break;
			}
		});

		var xhrUrl = actionUrl;
		var xhr = new window.XMLHttpRequest();

		xhr.open('POST', xhrUrl);
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				getResponse($form, xhr, token);
			}
		};
		xhr.send(formData);

		xhr.onload = function () {
			var responseObj = xhr.response;

			if (actionUrl.includes('PromoteScore') && responseObj) {
				noty('Thanks for your feedback', 'success', 3500);
			}
		};

		return false;
	}
};

/**
 * Обработка ответа от сервера
 * @param {jQuery} $form
 * @param {Object} xhr
 * @param {number} xhr.status
 * @param {string} xhr.statusText
 * @param {Object|string} xhr.response
 * @param {string} [xhr.response.redirect] - урл для редиректа, если равен текущему урлу - перегражаем страницу
 * @param {boolean} [xhr.response.reload] - перегрузить страницу
 * @param {boolean} [xhr.response.reset] - сбросить форму
 * @param {Array} [xhr.response.clear] - сбросить форму
 * @private
 */
function getResponse($form, xhr, token) {
	var status = xhr.status,
	    statusText = xhr.statusText,
	    response = xhr.response;

	var _$form$data = $form.data(),
	    preloader = _$form$data.preloader,
	    ajax = _$form$data.ajax,
	    analytics = _$form$data.analytics;

	var actionUrlSlow = ajax + 'Slow';

	// все плохо
	if (status !== 200) {
		console.log(xhr);
		window.alert(['Error!', 'status: ' + status, '--------------------', statusText].join('\n'));
		return false;
	}

	// обрабатываем ответ
	// ------------------

	if (typeof response === 'string') {
		response = JSON.parse(response);
	}

	if (response.success) {
		Cookies.set('w-form', true, { expires: 7 });

		if (window.fbq !== undefined) {
			window.fbq('track', 'Lead');
			console.info('Lead');
		}

		if (analytics) {
			var type = analytics.type;
			var code = void 0,
			    nameService = void 0;

			if (type === 'orderService') {
				if (analytics.service) {
					nameService = analytics.service;
				} else {
					nameService = $form.find('[data-name="type"]').val();
				}

				code = 'gtag("event","' + type + '-' + nameService + '",{"event_category":"' + type + '","event_label":"' + window.location.pathname + '"});';
				if (window.fbq !== undefined) {
					window.fbq('track', 'CompleteRegistration');
					console.info('Выполнена строка = fbq("track","CompleteRegistration")');
				} else {
					console.error('Объект fbq не определен! Строка НЕ выполнена = fbq("track","CompleteRegistration")');
				}
			} else {
				code = 'gtag("event","' + type + '-' + window.location.pathname + '",{"event_category":"' + type + '","event_label":"' + window.location.pathname + '"});';
			}

			if (window.ga !== undefined) {
				/* eslint-disable no-eval */
				eval(code);
				/* eslint-eneable no-eval */
				console.info('Выполнена строка = ' + code);
			} else {
				console.error('Объект ga не определен! Строка НЕ выполнена = ' + code);
			}
		}

		(function () {
			var $calc = $('.js-calculator');
			if ($calc.length) {
				var $list = $calc.find('.js-calc-list');
				$list.append($(response.html));
				window.Gapi.calculator.slideNext();
			}
		})();

		if (response.mfpClose && !$form.hasClass('js-video-after-form-letter01')) {
			$.magnificPopup.close();
		}

		if (response.lastID) {
			var requestSlow = new window.XMLHttpRequest();
			requestSlow.open('POST', actionUrlSlow);
			var formDataSlow = new window.FormData();
			formDataSlow.append('lastID', response.lastID);
			formDataSlow.append('token', token);
			requestSlow.send(formDataSlow);
		}

		if (response.clear) {
			if (Array.isArray(response.clear)) {
				response.clear.forEach(function (clearSelector) {
					$form.find(clearSelector).val('');
				});
			} else {
				// игнорируемые типы инпутов
				var ignoredInputsType = ['submit', 'reset', 'button', 'image'];
				$form.find('input, textarea, select').each(function (i, element) {
					if (~ignoredInputsType.indexOf(element.type)) {
						return true;
					}
					element.value = '';
				});
			}
		} else if (response.reset) {
			$form.trigger('reset');
		}

		if (!response.nopopap && response.response && !$form.hasClass('js-video-after-form-letter01')) {
			noty(response.response, 'success', 3500);
		}

		if (preloader) preloader.hide();
	} else {
		if ($form.find('.form-error').length) {
			$form.find('.form-error').text(response.response);
		} else {
			$('<div class="form-error">' + response.response + '</div>').prependTo($form);
		}
		if (preloader) preloader.hide();
	}

	if (response.reload || window.location.href === response.redirect) {
		return window.location.reload();
	}

	if (response.redirect) {
		return window.location.href = response.redirect;
	}

	if (response.clickSelector) {
		var $el = $(response.clickSelector);
		if ($el.length) {
			$el.click();
		}
	}
}

/**
 * Пользовательские обработчики формы
 * @param {jQuery} $form
 * @param {Object} Validator {@link https://jqueryvalidation.org/?s=validator}
 * @param {Function} Validator.resetForm {@link https://jqueryvalidation.org/Validator.resetForm/}
 */
function setHandlers($form, Validator) {
	// сброс формы
	$form.on('reset', function () {
		return Validator.resetForm();
	});
	// дальше ваш код
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function validation(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $forms = selector && selector.jquery ? selector : $(selector, $context);
	$forms.each(function (i, el) {
		var $form = $(el);

		$form.find('[data-form-input]').each(function (i, control) {
			var $field = $(control);

			$field.on('input paste change blur', function () {
				var $value = $field.val();
				$field.toggleClass('not-empty', !!$value && String($value).trim().length > 0);
			});

			$field.on('focus', function () {
				$field.addClass('not-empty');
			});

			$field.on('click', function () {
				$field.trigger('focus');
			});

			var $value = $field.val();
			$field.toggleClass('not-empty', !!$value && String($value).trim().length > 0);
		});

		if ($form.hasInitedKey('validator', false)) {
			return true;
		}

		var configUser = $form.data('validation-config') || {};
		var configCurrent = $.extend(true, configDefault, configUser);

		// phoneMask('[data-phone-mask]', $form);
		$form.validate(configCurrent);
		setHandlers($form, $form.data('validator'));

		if ($form.find('.custom-file').length) {
			customFile($form);
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = validation;

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// ----------------------------------------
// Public
// ----------------------------------------

function textareaAutoResize($textarea) {
	if (!$textarea.length) {
		return;
	}

	// Textarea Auto Resize
	var formHidden = $('.form-hidden').first();
	if (!formHidden.length) {
		formHidden = $('<div class="form-hidden"></div>');
		$('body').append(formHidden);
	}

	// Set font properties of formHidden
	var fontFamily = $textarea.css('font-family');
	var fontSize = $textarea.css('font-size');
	var lineHeight = $textarea.css('line-height');

	// Firefox can't handle padding shorthand.
	var paddingTop = $textarea.css('padding-top');
	var paddingRight = $textarea.css('padding-right');
	var paddingBottom = $textarea.css('padding-bottom');
	var paddingLeft = $textarea.css('padding-left');

	if (fontSize) {
		formHidden.css('font-size', fontSize);
	}
	if (fontFamily) {
		formHidden.css('font-family', fontFamily);
	}
	if (lineHeight) {
		formHidden.css('line-height', lineHeight);
	}
	if (paddingTop) {
		formHidden.css('padding-top', paddingTop);
	}
	if (paddingRight) {
		formHidden.css('padding-right', paddingRight);
	}
	if (paddingBottom) {
		formHidden.css('padding-bottom', paddingBottom);
	}
	if (paddingLeft) {
		formHidden.css('padding-left', paddingLeft);
	}

	// Set original-height, if none
	if (!$textarea.data('original-height')) {
		$textarea.data('original-height', $textarea.innerHeight());
	}

	if ($textarea.attr('wrap') === 'off') {
		formHidden.css('overflow-wrap', 'normal').css('white-space', 'pre');
	}

	formHidden.text($textarea.val() + '\n');
	var content = formHidden.html().replace(/\n/g, '<br>');
	formHidden.html(content);

	// When textarea is hidden, width goes crazy.
	// Approximate with half of window size

	if ($textarea.get(0).offsetWidth > 0 && $textarea.get(0).offsetHeight > 0) {
		formHidden.css('width', $textarea.width() + 'px');
	} else {
		formHidden.css('width', window.innerWidth / 2 + 'px');
	}

	/**
  * Resize if the new height is greater than the
  * original height of the textarea
  */
	if ($textarea.data('original-height') <= formHidden.innerHeight()) {
		$textarea.css('height', formHidden.innerHeight() + 'px');
	} else if ($textarea.val().length < $textarea.data('previous-length')) {
		/**
   * In case the new height is less than original height, it
   * means the textarea has less text than before
   * So we set the height to the original one
   */
		$textarea.css('height', $textarea.data('original-height') + 'px');
	}
	$textarea.data('previous-length', $textarea.val().length);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = textareaAutoResize;

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bookInit = undefined;

var _jsCookie = __webpack_require__(0);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bookInit = exports.bookInit = function bookInit() {
	var $element = $('[data-book]');

	if ($element.length) {
		window.document.addEventListener('mouseout', function (event) {
			var y = 0;
			if (event.touches && event.touches.length) {
				y = event.touches[0].clientY || 0;
			} else {
				y = event.clientY || 0;
			}

			if (y <= 0 && $.magnificPopup && !$.magnificPopup.instance.isOpen && !_jsCookie2.default.get('book')) {
				$element.trigger('click');
			}
		}, { passive: false });
	}
};

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Faq блок с аккордеоном
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
function faqAccordion() {
	var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $('body');

	$container.find('[data-faq-accordion]').each(function () {
		var item = $('.faq-accordion__title'),
		    answer = $('.faq-accordion__text');

		item.on('click', function () {
			var thisQuestion = $(this);

			function toggle() {
				thisQuestion.next().stop().slideToggle(300);
			}

			if (thisQuestion.next().is(':visible')) {
				toggle();
				thisQuestion.removeClass('is-open');
			} else {
				answer.filter(":visible").slideToggle(300);
				toggle();
				thisQuestion.addClass('is-open');
			}
		});
	});
}

exports.default = faqAccordion;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Внутрення, горизотальная прокрутка элементов со стилизацией
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(14);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Внутренний namespace
 * @const {string}
 * @private
 * @sourceCode
 */
var ns = 'horizontal-scroll';

/**
 * Список собранных элементов, к кототорым применен скролл
 * @type {Array}
 * @private
 * @sourceCode
 */
var $list = [];

/**
 * Обработчик собития `scroll.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {number} event.data.gap
 * @param {jQuery} event.data.$wrapper
 * @param {jQuery} event.data.$element
 * @private
 * @sourceCode
 */
function onScroll(event) {
  var $holder = $(this);
  var _event$data = event.data,
      gap = _event$data.gap,
      $wrapper = _event$data.$wrapper,
      $element = _event$data.$element;


  var holderWidth = $holder.innerWidth();
  var holderScroll = $holder.scrollLeft();
  var holderScrollOffset = holderScroll + holderWidth + gap;
  var tableWidth = $element[0].scrollWidth;

  var doClassLeft = 'removeClass';
  var doClassRight = 'removeClass';

  if (holderScroll > gap) {
    doClassLeft = 'addClass';
  }

  if (tableWidth > holderScrollOffset) {
    doClassRight = 'addClass';
  }

  $wrapper[doClassLeft](ns + '--left');
  $wrapper[doClassRight](ns + '--right');

  if ($holder.data(ns + '-synchronized') !== true) {
    $element.data(ns + '-$holders').forEach(function ($syncHolder) {
      $syncHolder.data(ns + '-synchronized', true);
      $syncHolder.scrollLeft(holderScroll);
    });
  }
  $holder.data(ns + '-synchronized', false);
}

/**
 * Обработчик собития `destroy.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @private
 * @sourceCode
 */
function onDestroy(event) {
  var _$this$off$unwrap$unw;

  var $this = $(this);
  var $holder = event.data.$holder;

  var index = $list.index($holder);
  if (~index) {
    $list.splice(index, 1);
    if ($list.length === 0) {
      $(window).off('resize.' + ns, onResize);
    }
  }
  $this.off('destroy.' + ns, onDestroy).unwrap().unwrap().removeClass(ns + '__element').removeInitedKey(ns).data((_$this$off$unwrap$unw = {}, _defineProperty(_$this$off$unwrap$unw, ns + '-$holder', null), _defineProperty(_$this$off$unwrap$unw, ns + '-$holders', null), _$this$off$unwrap$unw));
}

/**
 * Обработчик собития `mousedown.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onDown(event) {
  var _event$data2 = event.data,
      $holder = _event$data2.$holder,
      $wrapper = _event$data2.$wrapper;

  $wrapper.addClass(ns + '--mousedown');
  $holder.on('mousemove.' + ns, { $holder: $holder, $wrapper: $wrapper, downX: event.pageX }, onMove);
}

/**
 * Обработчик собития `mouseup.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onUp(event) {
  var _event$data3 = event.data,
      $holder = _event$data3.$holder,
      $wrapper = _event$data3.$wrapper;

  $wrapper.removeClass(ns + '--mousedown');
  $holder.off('mousemove.' + ns, onMove);
}

/**
 * Обработчик собития `mousemove.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onMove(event) {
  var gutter = 12;
  var _event$data4 = event.data,
      downX = _event$data4.downX,
      $holder = _event$data4.$holder,
      $wrapper = _event$data4.$wrapper;
  var x = event.pageX,
      y = event.pageY;


  var offset = $wrapper.offset();
  var left = offset.left + gutter;
  var top = offset.top + gutter;
  var right = left - gutter * 2 + $wrapper.innerWidth();
  var bottom = top - gutter * 2 + $wrapper.innerHeight();

  if (x < left || x > right || y < top || y > bottom) {
    $holder.trigger('mouseup.' + ns);
    return false;
  }
  var scroll = $holder.scrollLeft() - (x - downX) / 2;
  $holder.scrollLeft(scroll);
}

/**
 * Обработчик собития `destroy.${ns}` для `window`
 * @private
 * @sourceCode
 */
function onResize() {
  if ($list.length) {
    $list.trigger('scroll');
  }
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Оборачивание элементов и добавление прослушки на горизотальную прокрутку.
 * При инициализации каждому элементу добавляеться запись `data('horizontal-scroll', true)`
 * Для того чтобы отфильтровывать уже инициализированные элементы при возможных последующих обращениях
 *
 * Каждому элементу добавляеться CSS класс, а также оборачивается нужной разметкой
 * для стилизации и возможность устастановки прослушек.
 *
 * Пример начальной разметки
 *
 * ```markup
 * <div class="wysiwyg">
 *     <table>
 *         <!-- content -->
 *     </table>
 * </div>
 * ```
 *
 * Пример результата
 *
 * ```markup
 * <div class="wysiwyg">
 *     <div class="horizontal-scroll"> <!-- Стилизация псевдоэлементами слева и справа в зависимости от прокрутки -->
 *         <div class="horizontal-scroll__holder"> <!-- Создает прокрутку и не нем же весят события скрола -->
 *             <table class="horizontal-scroll__element">
 *                 <!-- content -->
 *             </table>
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Инит таблиц</caption>
 * horizontalScroll('.wysiwyg table');
 *
 * @example <caption>Инит таблиц в текущем контейнере</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Инит таблиц в текущем контейнере с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer, 20);
 *
 * @example <caption>Инит таблиц с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', null, 20);
 *
 * @param {string|jQuery} selector - поиск элементов по селектору или jQuery element
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @param {number} [gap=4] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @sourceCode
 */
function horizontalScroll(selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

  var $elements = selector && selector.jquery ? selector : $(selector, $context);

  $elements.each(function (i, el) {
    var $element = $(el);

    if ($element.hasInitedKey(ns, false)) {
      return true;
    }

    $element.addClass(ns + '__element').wrap('<div class="' + ns + '"><div class="' + ns + '__holder"></div></div>');
    horizontalScroll.init($element, gap);
  });
}

/**
 * Инициализация прослушки
 * Метод можно использовать отдельно, если у вас уже есть готовая структура разметки
 *
 * Необходимая структура
 *
 * ```markup
 * <div class="horizontal-scroll">
 *     <div class="horizontal-scroll__holder">
 *         <div class="horizontal-scroll__element">
 *             <!-- content -->
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Необходимая структура</caption>
 * let $element = $('.horizontal-scroll__element);
 * horizontalScroll.init($element);
 * // horizontalScroll.init($element, 20); // => с зазором в 20 пикселей
 *
 * @param {jQuery} $element - поиск элементов по селектору
 * @param {number} [gap=3] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @method horizontalScroll::init
 * @inner
 */
horizontalScroll.init = function ($element) {
  var gap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  if ($element.hasInitedKey(ns)) {
    return true;
  }

  var $holder = $element.parent();
  var $wrapper = $holder.parent();

  $holder.on('scroll.' + ns, { gap: gap, $element: $element, $wrapper: $wrapper }, onScroll);
  $holder.on('mousedown.' + ns, { $holder: $holder, $wrapper: $wrapper }, onDown);
  $holder.on('mouseup.' + ns, { $holder: $holder, $wrapper: $wrapper }, onUp);
  $holder.on('dragstart.' + ns, function () {
    return false;
  });
  $element.on('destroy.' + ns, { $holder: $holder }, onDestroy);
  $element.data(ns + '-$holder', $holder);
  $element.data(ns + '-$holders', []);

  if ($list.length) {
    $list = $list.add($holder);
  } else {
    $list = $holder;
    $(window).on('resize.' + ns, onResize);
  }

  $holder.trigger('scroll.' + ns);
};

/**
 * Синхронизация скролов
 * __Важно!__ метод нужно вызывать после инициализации скролов для каждлго из элементов
 *
 * @example
 * let $elements = $('.elements');
 * horizontalScroll($elements);
 * horizontalScroll.sync($elements);
 *
 * @param $elements
 * @method horizontalScroll::sync
 * @inner
 * @sourceCode
 */
horizontalScroll.sync = function ($elements) {
  $elements.each(function (i, el) {
    var $el = $(el);
    var $holders = [];

    $elements.not($el).each(function (i, el) {
      $holders.push($(el).data(ns + '-$holder'));
    });

    $el.data(ns + '-$holders', $holders);
  });
};

/**
 * Удаление внутреннего скролла
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table');
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Удаление внутреннего скрола с нужного элемента</caption>
 * horizontalScroll.destroy($myElement);
 *
 * @param {string|jQuery} selector - Селектор или jQuery элемент
 * @param {string} selector.jquery - Если передан элемент - строка, содержащая номер версии `jQuery` ({@link http://api.jquery.com/jquery-2/})
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @method horizontalScroll::destroy
 * @inner
 */
horizontalScroll.destroy = function (selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (selector && selector.jquery) {
    selector.trigger('destroy.' + ns);
    return;
  }

  $(selector, $context).each(function (i, el) {
    var $element = $(el);
    $element.trigger('destroy.' + ns);
  });
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = horizontalScroll;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Оборачивание элементов для пропорцинальной адаптации
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(14);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function wrapMedia(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $el = $(el);
		if ($el.hasInitedKey('wrap-media', false)) {
			return true;
		}

		var width = parseInt($el.attr('width') || $el[0].offsetWidth);
		var height = parseInt($el.attr('height') || $el[0].offsetHeight);
		var ratio = parseFloat((height / width * 100).toFixed(2));

		$el.unwrap('p').wrap('\n\t\t<div class="ratio-wrapper" style="max-width:' + width + 'px;margin-left:auto;margin-right:auto;">\n\t\t\t<div class="ratio" style="padding-top:' + ratio + '%;"></div>\n\t\t</div>\n\t\t');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = wrapMedia;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _intlTelInput = __webpack_require__(143);

var _intlTelInput2 = _interopRequireDefault(_intlTelInput);

__webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setInputMask($element) {
	var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '99 999 9999';

	$element.inputmask({
		mask: mask,
		clearMaskOnLostFocus: false,
		androidHack: window.Modernizr.android,
		disablePredictiveText: window.Modernizr.android,
		oncomplete: function oncomplete() {
			$element.data('valid', true);
		},
		onincomplete: function onincomplete() {
			$element.data('valid', false);
		}
	}).on('change.isComplete', function () {
		$element.data('valid', $element.inputmask('isComplete'));
	});
}

function phoneInput() {
	var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $('body');

	$container.find('.js-phone-input').each(function () {
		var $element = $(this);
		var iti = (0, _intlTelInput2.default)(this, {
			dropdownContainer: document.body,
			initialCountry: 'us',
			preferredCountries: ['us', 'ca', 'gb', 'de'],
			separateDialCode: true,
			autoPlaceholder: 'aggressive',
			utilsScript: '/Media/js/intl-tel-input-utils.js'
		});
		$element.on('countrychange', function () {
			var mask = $element.attr('placeholder');
			var countryData = iti.getSelectedCountryData();
			$element.val('');
			$element.data('code', countryData.dialCode);
			$element.attr('placeholder', mask.replace(/[0-9]/g, '_'));
			setInputMask($element, mask.replace(/[0-9]/g, 9));
		});
		$element.data('code', '1');
		$element.attr('placeholder', '___ ___ ____');
		setInputMask($element, '999-999-9999');
	});
}

exports.default = phoneInput;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

    $container.find('[data-tabs-button]').on('click', function () {
        var $this = $(this);
        var ns = $this.data('tabs-ns');
        var key = $this.data('tabs-button');

        var $buttons = $container.find('[data-tabs-ns="' + ns + '"][data-tabs-button]');
        var $blocks = $container.find('[data-tabs-ns="' + ns + '"][data-tabs-block]');

        var $buttonsOther = $buttons.filter(':not([data-tabs-button="' + key + '"])');
        var $blocksOther = $blocks.filter(':not([data-tabs-block="' + key + '"])');
        var $buttonsCurrent = $buttons.filter('[data-tabs-button="' + key + '"]');
        var $blocksCurrent = $blocks.filter('[data-tabs-block="' + key + '"]');

        $buttonsOther.removeClass('is-active');
        $blocksOther.removeClass('is-active');
        $buttonsCurrent.addClass('is-active');
        $blocksCurrent.addClass('is-active');

        $buttonsOther.trigger('tabs-off');
        $buttonsCurrent.trigger('tabs-on');

        if ($blocksCurrent.find('.js-animation')) {
            $blocksCurrent.find('.js-animation').show('slow');
            setTimeout(function () {
                $blocksCurrent.find('.js-animation').hide('slow');
            }, 4000);
        }
        if ($blocksCurrent.find('.js-content')) {
            setTimeout(function () {
                $blocksCurrent.find('.js-content').show('slow');
            }, 4000);
        }
    });
    $container.find('[data-hover-button]').on('mouseenter', function () {
        var $this = $(this);
        var ns = $this.data('hover-ns');
        var key = $this.data('hover-button');

        var $buttons = $container.find('[data-hover-ns="' + ns + '"][data-hover-button]');
        var $blocks = $container.find('[data-hover-ns="' + ns + '"][data-hover-block]');

        var $buttonsOther = $buttons.filter(':not([data-hover-button="' + key + '"])');
        var $blocksOther = $blocks.filter(':not([data-hover-block="' + key + '"])');
        var $buttonsCurrent = $buttons.filter('[data-hover-button="' + key + '"]');
        var $blocksCurrent = $blocks.filter('[data-hover-block="' + key + '"]');

        $buttonsOther.removeClass('is-active');
        $blocksOther.removeClass('is-active');
        $buttonsCurrent.addClass('is-active');
        $blocksCurrent.addClass('is-active');

        $buttonsOther.trigger('hover-off');
        $buttonsCurrent.trigger('hover-on');
    });

    $container.find('[data-accordion-button]').on('click', function () {
        var $this = $(this);
        var ns = $this.data('accordion-ns');
        var key = $this.data('accordion-button');

        var $buttons = $container.find('[data-accordion-ns="' + ns + '"][data-accordion-button="' + key + '"]');
        var $blocks = $container.find('[data-accordion-ns="' + ns + '"][data-accordion-block="' + key + '"]');

        if ($this.hasClass('is-active')) {
            $buttons.removeClass('is-active');
            $blocks.removeClass('is-active');
        } else {
            $buttons.addClass('is-active');
            $blocks.addClass('is-active');
        }
    });
};

var _sprite = __webpack_require__(41);

var _sprite2 = _interopRequireDefault(_sprite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

    $container.find('[data-wysiwyg-blog]');
    var heading = $container.find('[data-wysiwyg-blog] #heading');
    var animation = $container.find('[data-sprite-animation]');
    heading.append(animation);

    var blog = document.querySelector('[data-wysiwyg-blog] #heading');

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (typeof getCurrentAnimationPreference === 'function' && !getCurrentAnimationPreference()) {
                return;
            }
            if (entry.isIntersecting) {
                if ($container.find('.sprite')) {
                    $container.find('.sprite').addClass('is-show');
                    $container.find('.sprite__tooltip').show('slow');
                }
            } else {
                if ($container.find('.sprite')) {
                    $container.find('.sprite').removeClass('is-show');
                    $container.find('.sprite__tooltip').show('slow');
                }
            }
        });
    });
    observer.observe(blog);
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инциализация swiper
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var presets = {
	'default': {
		loop: true,
		pagination: {
			el: '.js-default-slider-pagination',
			type: 'bullets',
			clickable: true,
			bulletClass: 'default-slider__bullet',
			bulletActiveClass: 'default-slider__bullet--active'
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function slideChange() {
				window.lazyLoad.observe();
			}
		}
	},
	review: {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoHeight: true,
		preloadImages: false,
		lazy: {
			loadPrevNext: true
		},
		pagination: false,
		simulateTouch: false,
		allowSwipeToNext: false,
		allowSwipeToPrev: false,
		on: {
			lazyImageLoad: function lazyImageLoad() {
				this.update();
			}
		}
	},
	calculator: {
		loop: false,
		allowTouchMove: false,
		speed: 500,
		autoHeight: true,
		passiveListeners: false,
		lazy: {
			loadPrevNext: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			init: function init() {
				var $before = $('.before-load');
				$before.removeClass('before-load');
				this.update();

				$('.js-swiper-next').on('click', function () {
					$(this).find('input').prop('checked', true);
				});
			}
		}
	},
	'review-image': {
		loop: true,
		lazy: {
			loadPrevNext: true
		},
		pagination: {
			el: '.js-default-slider-pagination',
			type: 'bullets',
			bulletClass: 'default-slider__bullet',
			bulletActiveClass: 'default-slider__bullet--active',
			clickable: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function slideChange() {
				if (window.Gapi['review']) {
					window.Gapi['review'].slideTo(this.activeIndex);
				}
			}
		}
	},
	'projects': {
		loop: true,
		lazy: {
			loadPrevNext: true
		},
		pagination: {
			el: '.js-projects-slider-pagination',
			type: 'bullets',
			bulletClass: 'projects-slider__dot',
			bulletActiveClass: 'projects-slider__dot--active',
			clickable: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function slideChange() {
				var image = $(".first-screen__image"),
				    src = this.$wrapperEl.find('.swiper-slide-active').next().data('src');
				image.css({ 'opacity': '0.9', 'transform': 'scale(1.02)' }).attr('src', src);

				setTimeout(function () {
					image.css({ 'opacity': '1', 'transform': 'scale(1)' });
				}, 500);
			}
		}
	},
	'clients': {
		slidesPerView: 'auto',
		breakpoints: {
			640: {
				slidesPerView: 7
			}
		}
	},
	'industries': {
		loop: true,
		lazy: {
			loadPrevNext: true
		}
	},
	'industries-clutch': {
		loop: false,
		allowTouchMove: false,
		speed: 500,
		autoHeight: true,
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		scrollbar: {
			el: ".swiper-scrollbar"
		}
	},
	'industries-slider': {
		slidesPerView: 1,
		loop: false,
		allowTouchMove: true,
		speed: 500,
		autoHeight: true,
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		}
	},
	'books': {
		slidesPerView: 3,
		loop: false,
		allowTouchMove: true,
		autoplay: {
			delay: 2500
		},
		speed: 1000,
		autoHeight: true,
		preloadImages: false,
		lazy: {
			loadPrevNext: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		pagination: false,
		simulateTouch: true,
		allowSwipeToNext: false,
		allowSwipeToPrev: false,
		breakpoints: {
			732: {
				slidesPerView: 1,
				spaceBetween: 15
			},
			1980: {
				slidesPerView: 3,
				spaceBetween: 15,
				autoplay: false
			}
		}
	}
};

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */
function swiper(selector) {
	window.Gapi = {};
	$(selector).each(function () {
		var $this = $(this);
		var preset = $this.data('preset') || 'default';
		var initWidth = $this.data('init-width');
		if (!initWidth || initWidth && $(window).width() < +initWidth) {
			window.Gapi[preset] = new window.Swiper(this, presets[preset]); // eslint-disable-line no-new
		} else {
			$this.find('.swiper-lazy-preloader').remove();
			$this.find('.swiper-lazy').each(function () {
				var data = $(this).data('src');
				$(this).attr('src', data);
			});
		}
	});
}

function swiperInput() {
	var $swiper = $('.js-swiper');
	var $slid = $swiper.find('.swiper-slide');
	if ($swiper.length) {
		if ($slid.length > 1) {
			__webpack_require__.e/* require.ensure */(3).then((function () {
				window.Swiper = __webpack_require__(161);
				__webpack_require__(162);
				swiper('.js-swiper');
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		} else if ($slid.length === 1) {
			$swiper.addClass('is-one');
			$slid.css('background-image', 'url(' + $slid.data('background') + ')');
		}
	}
}

exports.default = swiperInput;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(46);

__webpack_require__(51);

__webpack_require__(43);

__webpack_require__(52);

var _jsCookie = __webpack_require__(0);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

__webpack_require__(53);

__webpack_require__(55);

__webpack_require__(56);

__webpack_require__(57);

__webpack_require__(59);

__webpack_require__(60);

__webpack_require__(61);

__webpack_require__(62);

__webpack_require__(67);

__webpack_require__(68);

__webpack_require__(69);

var _horizontalScroll = __webpack_require__(21);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(22);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _validation = __webpack_require__(15);

var _validation2 = _interopRequireDefault(_validation);

var _magnificPopup = __webpack_require__(74);

var _trigger = __webpack_require__(146);

var _phoneInput = __webpack_require__(39);

var _phoneInput2 = _interopRequireDefault(_phoneInput);

var _locomotiveScroll = __webpack_require__(147);

var _locomotiveScroll2 = _interopRequireDefault(_locomotiveScroll);

var _animate = __webpack_require__(13);

var _animate2 = _interopRequireDefault(_animate);

var _sprite = __webpack_require__(41);

var _sprite2 = _interopRequireDefault(_sprite);

var _lightgallery = __webpack_require__(149);

var _lightgallery2 = _interopRequireDefault(_lightgallery);

var _textareaAutoResize = __webpack_require__(153);

var _textareaAutoResize2 = _interopRequireDefault(_textareaAutoResize);

var _tabs = __webpack_require__(40);

var _tabs2 = _interopRequireDefault(_tabs);

var _book = __webpack_require__(154);

var _swiper = __webpack_require__(42);

var _swiper2 = _interopRequireDefault(_swiper);

var _faqAccordion = __webpack_require__(155);

var _faqAccordion2 = _interopRequireDefault(_faqAccordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Public
// ----------------------------------------

// new
window.jQuery(document).ready(function ($) {
	var $windowScroll = $('[data-scroll-window]');
	if ($windowScroll.length) {
		__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 163)).then(function (module) {
			module.default($windowScroll);
		});
	}
	(0, _horizontalScroll2.default)('.wysiwyg table');
	(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video');
	(0, _validation2.default)('.js-form');
	(0, _magnificPopup.mfpAjax)('.js-mfp-ajax');
	(0, _magnificPopup.mfpIframe)('.js-mfp-iframe');
	(0, _magnificPopup.mfpImage)('.js-mfp-image');
	(0, _magnificPopup.mfpWysiwyg)('.wysiwyg');
	(0, _magnificPopup.mfpWysiwyg)('.js-footerTab');
	(0, _faqAccordion2.default)();
	(0, _swiper2.default)();
	(0, _trigger.trigger)();
	(0, _phoneInput2.default)();
	(0, _locomotiveScroll2.default)();
	(0, _animate2.default)();
	(0, _sprite2.default)();
	(0, _lightgallery2.default)();
	setTtextareaAutoResize();
	(0, _tabs2.default)();
	(0, _book.bookInit)();
});

$('.go-to-new-site__close').on('click', function () {
	$('.go-to-new-site').remove();
	_jsCookie2.default.set('go-new-site', 1, { expires: 86400 });
});

$(".attachment__input").change(function () {
	var filename = $(this).val().replace(/.*\\/, "");
	if (!filename.length) {
		$(".attachmen__text").html('Add an attachment');
	} else {
		$(".attachmen__text").html(filename);
	}
});

window.sss = function () {
	var now = new Date().getTime();
	var prevShow = window.localStorage.getItem('blog-popup');
	if (!prevShow || Number(prevShow) + 24 * 60 * 60 * 1000 < now) {
		var pop = false;

		window.mgn = function () {
			pop = true;
			window.localStorage.setItem('blog-popup', now);

			$('.mybtns').trigger('click');
		};

		window.stm = function () {
			setInterval(function () {
				if (!pop) {
					window.mgn();
				}
			}, 15000);
		};

		window.stm();

		window.blogs = function () {
			document.addEventListener('mouseleave', function (e) {
				if (e.clientY < 0 && !pop) {
					window.mgn();
				}
			}, false);
		};

		window.blogs();
	}
};

var urlTNP = document.location.href;
var positionURL = urlTNP.indexOf('prodvizhenie_sajtov_za_rubezhom');

if (positionURL > 0) {
	window.sss();
}

function setTtextareaAutoResize() {
	$('textarea[data-form-input]').each(function () {
		var $control = $(this);
		(0, _textareaAutoResize2.default)($control);
		$control.on('input keyup paste change', function () {
			(0, _textareaAutoResize2.default)($control);
		});
	});
}

if (document.querySelector('.js-gmap')) {
	window.initMap = function () {
		__webpack_require__.e/* require.ensure */(5).then((function () {
			__webpack_require__(164);
		}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
	};
}

if (document.querySelector('#telegram')) {
	var hulfHeight = $(document).height() / 2;

	$(document).scroll(function () {
		if ($(this).scrollTop() > hulfHeight) {
			$('#telegram').click().remove();
		}
	});
}

if (document.querySelector('#promote-score')) {
	setTimeout(function () {
		$('#promote-score').click();
	}, 40000);
}

var viewWebinarPopup = $('#viewPopupWebinar');
if (viewWebinarPopup.length) {
	setTimeout(function () {
		viewWebinarPopup.click();
	}, 10000);
}

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит плгина lozad.js
 * @module
 * @see {@link https://github.com/ApoorvSaxena/lozad.js}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

__webpack_require__(20);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Добавлеям `lazyLoad` к глобальныму объекту `window`
 */

function attrData(el, name) {
	if (typeof el.data(name) !== 'undefined') {
		el.attr(name, el.data(name));
	}
}

function onLoad($el) {
	var $parent = $el.parent('.lazy-load');
	if (!$parent.length) {
		$parent = $el;
	}
	$parent.addClass('is-ready').removeClass('is-start');
}

function createLazyLoad() {
	var lozad = __webpack_require__(54);
	window.lazyLoad = lozad('.lozad', {
		rootMargin: '100px 0px 100px 0px',
		load: function load(el) {
			var $el = $(el);
			$el.addClass('is-start');
			var src = $el.data('src');
			var img = document.createElement('img');
			var nodeName = $el.nodeName();

			if (nodeName === 'picture') {
				if (!$el.find('img').length) {
					img.onload = function () {
						onLoad($el);
					};
					$el.append(img);
				} else {
					var $parent = $el.parent('.lozad');
					if (!$parent.length) {
						$parent = $el;
					}
					$parent.addClass('is-ready').removeClass('is-start');
				}
			} else {
				img.onload = function () {
					if (nodeName === 'img') {
						attrData($el, 'src');
					} else if (nodeName === 'video') {
						attrData($el, 'poster');
					} else {
						$el.css('background-image', 'url(' + src + ')');
					}
					onLoad($el);
				};
				img.src = src;
			}
		}
	});
	window.lazyLoad.observe();
}

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	if (!$('.lozad').length) {
		return false;
	}

	// если уже `lazyLoad` добавлен вызываем
	if (window.lazyLoad) {
		return window.lazyLoad.observe();
	}

	// иначе добавляем
	if (window.Modernizr.intersectionobserver) {
		createLazyLoad();
	} else {
		// грузим асинхронно полифилл если не поддерживается Intersection Observer
		__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
			__webpack_require__(44);
			createLazyLoad();
		}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
	}
})(window.jQuery);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инциализация mmenu
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */

function mMenu(selector) {
	var $menu = $(selector);
	$menu.mmenu({
		navbar: {
			title: 'Wezom'
		},
		backButton: true,
		extensions: ['fullscreen'],
		navbars: [{
			position: 'top',
			content: ['<button id="close-menu" class="link-burger"><span class="link-burger__icon"></span></button>']
		}, true]
	});

	var API = $menu.data("mmenu");

	$("#close-menu").click(function () {
		API.close();
	});
}

function loadMenu() {
	if (typeof $.mmenu === 'undefined' && $(window).width() < 1025) {
		__webpack_require__.e/* require.ensure */(2).then((function () {
			__webpack_require__(157);
			__webpack_require__(158);
			mMenu('#js-mmenu');
		}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
	}
}

(function ($) {
	loadMenu();

	$(window).resize(function () {
		loadMenu();
	});
})(window.jQuery);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инциализация mcustomscrollbar
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */

function mCustomScroll(selector) {
	$(selector).mCustomScrollbar();
}

(function () {
	if (!window.Modernizr.cssscrollbar && !window.Modernizr.touchevents) {
		__webpack_require__.e/* require.ensure */(1).then((function () {
			__webpack_require__(156);
			__webpack_require__(159);
			__webpack_require__(160);
			mCustomScroll('.js-customscroll');
		}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
	}
})(window.jQuery);

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _animate = __webpack_require__(13);

var _animate2 = _interopRequireDefault(_animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTo(offsetNumber) {
	var ofTop = void 0;
	if ($.isNumeric(offsetNumber)) {
		ofTop = offsetNumber;
	} else {
		ofTop = $(offsetNumber).offset().top;
	}

	$('html, body').stop().animate({
		scrollTop: ofTop
	}, 700);
}

(function ($) {
	var $topBtn = $('.js-top');
	var $chatBtn = $('.js-bwidget');
	var $window = $(window);

	$('.js-down').on('click', function () {
		scrollTo('.js-down-section');
	});
	//
	// $('.js-anchors').on('click', '.js-anchors-item', function () {
	// 	scrollTo($(this).attr('href'));
	// });
	//
	// $('.js-anchor').on('click', function () {
	// 	scrollTo($(this).attr('href'));
	// });

	/* $('.js-binotel').on('click', () => {
 	$('#bingc-phone-button-tooltip').trigger('click');
 }); */

	$('body').on('click', '.js-mfp-close', function () {
		$.magnificPopup.close();
	});

	$chatBtn.on('touchend mouseleave mousedown', function (e) {
		if (e.type === 'touchend') {
			$chatBtn.toggleClass('is-open');
		}

		if (e.type === 'mouseleave') {
			$chatBtn.removeClass('is-open');
		}

		if (e.type === 'mousedown') {
			$chatBtn.addClass('is-open');
		}
	});

	// $topBtn.on('click', () => {
	// 	scrollTo(0);
	// });

	$window.on('scroll', function () {
		if ($window.scrollTop() > 100) {
			$topBtn.addClass('is-visible');
		} else {
			$topBtn.removeClass('is-visible');
		}
	});

	var page = 1;

	$('.js-portfolio').on('click', function () {
		var it = $(this);
		var ajax = it.data('ajax');
		var target = it.data('target');

		if (ajax && target && !it.hasClass('disabled')) {
			it.addClass('disabled').css({ 'opacity': '0.35' });

			$.ajax({
				url: '/ajax/general/' + ajax,
				type: 'POST',
				dataType: 'JSON',
				data: {
					page: page
				},
				success: function success(data) {
					if (data.success) {
						var $html = $(data.html);
						(0, _animate2.default)($html);
						$html.appendTo(target);
						if (data.remove) {
							it.remove();
						}
					}
					window.lazyLoad.observe();
					it.removeClass('disabled').css({ 'opacity': '1' });
					page = page + 1;
				}
			});
		}
	});

	$('body').on('click', '.js-button-video', function () {
		if (!$(this).closest('form').valid()) return false;
		$(this).closest('form').submit();
		$.magnificPopup.close();
		setTimeout(function () {
			var nowHours = new Date().getHours();
			var nowDay = new Date().getDay();
			var nowWork = nowDay > 0 && nowDay < 6 && nowHours >= 9 && nowHours < 18;
			var video = nowWork ? 'https://www.youtube.com/watch?v=R7_3g-EM04U' : 'https://www.youtube.com/watch?v=uTyEeSGoLDg';
			$.magnificPopup.open({
				items: [{
					src: video
				}],
				mainClass: 'zoom-in',
				type: 'iframe',
				closeBtnInside: true,
				autoFocusLast: false,
				fixedContentPos: false,
				removalDelay: 200,
				iframe: {
					markup: '<div class="magnific-popup mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>'
				}
			});
		}, 250);
	});
})(window.jQuery);

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IO = function () {
	function IO() {
		_classCallCheck(this, IO);

		this.options = {
			rootMargin: '0px',
			threshold: 0
		};
		this.observer = null;
		this.callbackBefore = function (element, observer) {
			observer.observe(element);
		};
		this.callback = function (entry) {};
		this.callbackAfter = function (element, observer) {
			observer.unobserve(element);
		};
	}

	_createClass(IO, [{
		key: 'init',
		value: function init($elements) {
			var _this = this;

			if (window.IntersectionObserver) {
				this.observer = new window.IntersectionObserver(function (entries) {
					entries.forEach(function (entry) {
						_this.callback(entry);
					});
				}, this.options);
				$elements.each(function (index, element) {
					_this.callbackBefore(element, _this.observer);
				});
			}
		}
	}, {
		key: 'setOptions',
		value: function setOptions(options) {
			this.options = Object.assign(this.options, options);
		}
	}, {
		key: 'setBefore',
		value: function setBefore(callback) {
			this.callbackBefore = callback;
		}
	}, {
		key: 'setCallback',
		value: function setCallback(callback) {
			this.callback = callback;
		}
	}, {
		key: 'setAfter',
		value: function setAfter(callback) {
			this.callbackAfter = callback;
		}
	}, {
		key: 'observe',
		value: function observe($elements, callback) {
			var _this2 = this;

			if (window.IntersectionObserver) {
				this.init($elements, callback);
			} else {
				__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 44)).then(function () {
					_this2.init($elements, callback);
				});
			}
		}
	}, {
		key: 'unobserve',
		value: function unobserve($elements) {
			var _this3 = this;

			if (this.observer) {
				$elements.each(function (index, element) {
					_this3.callbackAfter(element);
				});
			}
		}
	}]);

	return IO;
}();

exports.default = IO;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Top Button
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	// let numberRating = 0;
	// let votedRating = 13;

	$('.rating-blog__label').on('click', function () {
		var it = $(this);

		var value = it.data('value');

		$.ajax({
			url: it.closest('.rating-blog__mark').data('url'),
			type: 'POST',
			dataType: 'JSON',
			data: {
				number: value,
				id: it.closest('.rating-blog__mark').data('id')
			},
			success: function success(data) {
				// if (data.success) {}
				// $('.rating-blog__status').addClass('rating-blog__status--ok');

				$.magnificPopup.open({
					items: {
						src: '<div class="noty magnific-popup magnific-popup--noty">\n\t\t\t\t\t\t<div class="noty__message">' + data.message + '</div>\n\t\t\t\t\t\t<button class="button button--yellow js-mfp-close">\n\t\t\t\t\t\t\t<span class="button__text">Close</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>',
						type: 'inline'
					},
					removalDelay: 200,
					mainClass: 'zoom-in',
					autoFocusLast: false,
					fixedContentPos: false
				});

				$('[data-rating]').text(data.number);
				$('[data-voted]').text(data.voted);

				it.closest('.rating-blog__mark').removeClass('is-active').addClass('is-disabled');
			}
		});
	});
})(window.jQuery);

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Фиксированный хедер с функцией сворчанивания при скроле
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-navpanel"]- поиск элементов по селектору
 * @sourceCode
 */

(function ($) {
	// set scrolling variables
	var scrolling = false;
	var previousTop = 0;
	var scrollDelta = 5;
	var scrollOffset = 50;
	var $selector = $('.js-navpanel');
	var $body = $('body');
	var $window = $(window);

	$window.on('scroll', function () {
		if (!scrolling) {
			scrolling = true;
			!window.requestAnimationFrame ? setTimeout(autoHideHeader, 250) : window.requestAnimationFrame(autoHideHeader);
		}
	});

	autoHideHeader();

	function autoHideHeader() {
		var currentTop = $window.scrollTop();

		if (previousTop - currentTop > scrollDelta) {
			$body.addClass('show-header');
		} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
			$body.addClass('show-w');
			$body.removeClass('show-header');
		}

		if (currentTop < scrollOffset) {
			$body.removeClass('show-header show-w');
		}

		previousTop = currentTop;
		scrolling = false;
	}
})(window.jQuery);

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Переключение табов в футере
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-footerTab"]- поиск элементов по селектору
 * @sourceCode
 */

(function ($) {
  var tab = $('.footer-tab__link');

  tab.on('click', function () {
    $(this).addClass('is-active').siblings().removeClass('is-active').closest('.js-footerTab').find('.footer-tab__block').addClass('_hide').eq($(this).index()).removeClass('_hide');
  });
})(window.jQuery);

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инциализация in-view
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

var _inView = __webpack_require__(63);

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	if ($('.title--big,.title--bigest').length) {
		var title = new _inView2.default();
		title.threshold(0.8);
		title('.title--big,.title--bigest').on('enter', function (el) {
			var $el = $(el);
			$el.addClass('is-anim');
			setTimeout(function () {
				$el.removeClass('has-anim');
				$el.children().children('.lt-anim').removeAttr('style');
			}, 2000);
		});
	}

	var $el = $('.js-fix-buttons');

	if ($el.length) {
		var fix = new _inView2.default();
		var wh = $(window).height();
		var hid = 'is-hidden';
		var wh2 = wh < $(window).width() ? wh / 2 : wh;
		fix.threshold(0);
		fix.offset({
			top: wh2,
			bottom: wh2
		});
		fix('.buttons-fix-container').on('enter', function (el) {
			$el.removeClass(hid);
		}).on('exit', function (el) {
			$el.addClass(hid);
		});
	}
})(window.jQuery);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Top Load
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

__webpack_require__(0);

var Cookies = __webpack_require__(0);

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	$(window).on('load', function () {
		//  отключение всплывающей формы Бинотела
		if ($('#disabled-binotel').length) {
			var bgc = window.BinotelGetCall;

			if (typeof bgc !== 'undefined') {
				bgc[Object.keys(bgc)[0]].activeFormStatus = 0;
			}
		}

		// Удаление стандартного CSS от бинотела
		(function () {
			var count = 10;
			var interval = setInterval(function () {
				count--;
				var style = document.head.querySelector('link[rel="stylesheet"][href*="getcall/css/theme"]');
				if (style) {
					style.remove();
					document.documentElement.classList.add('custom-binotel');
					clearInterval(interval);
				}
				if (count <= 0) {
					clearInterval(interval);
					console.info('Используется стандартный стиль от Binotel');
				}
			}, 500);
		})();

		/* setTimeout(function () {
     if (window.location.hash === '#day') {
         document.getElementById('bingc-active-content').innerHTML = `
  <div class="bingc-we-will-call-you">Хотите, перезвоним Вам<br>в течение 10 минут?</div>
  <div class="bingc-active-get-phone-form">
  <form id="bingc-active-get-phone-form" class="bingc-active-get-phone-form">
  <div class="bingc-active-get-phone-form-input-border"></div>
  <input type="tel" id="bingc-active-get-phone-form-input" class="bingc-active-get-phone-form-input" placeholder="Ваш номер телефона" value="" autocomplete="off" onfocus="this.value = this.value;">
  <a href="javascript:void(0);" class="bingc-active-phone-form-button">Перезвоните</a>
  <span class="bingc-sample-countdown-timer"><span>00:</span>29<span>:99</span></span>
  </form>
  </div>
  <div id="bingc-phone-sample" class="bingc-phone-sample"><span>Например: 067 000 00 00</span></div>
  <div class="bingc-statistics">Свободных операторов на линии: 3 Заказов звонков сегодня: 20+</div>`;
     } else {
         document.getElementById('bingc-active-content').innerHTML = `
  <div class="bingc-active-content" id="bingc-active-content">
  <div class="bingc-we-will-call-you bingc-offline-form">Хотите, перезвоним Вам<br>
  <div id="bingc-active-date-selection-select-day" class="bingc-active-date-selection-select-day bingc-active-date-selection-select-day-hover">
  <svg class="bingc-active-date-selection-arrows" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 14" enable-background="new 0 0 10 14" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M0,4.995L4.995,0L9.99,4.995"></path></svg>
  <span id="bingc-active-date-selection-selected-day" class="bingc-active-date-selection-selected-day">завтра</span><input type="hidden" id="bingc-active-date-selection-selected-day-index" value="0">
  <div id="bingc-active-date-selection-select-day-list-of-days-container" class="bingc-active-date-selection-select-day-list-of-days-container">
  <ul id="bingc-active-date-selection-select-day-list-of-days" class="bingc-active-date-selection-select-day-list-of-days">
  <li value="0">завтра</li>
  <li value="1">в понедельник</li>
  <li value="2">во вторник</li>
  </ul>
  </div>
  </div>
  точно в:
  </div>
  <div class="bingc-active-get-phone-form bingc-offline-form">
  <form id="bingc-active-get-phone-form" class="bingc-active-get-phone-form">
  <div class="bingc-active-get-phone-form-date-selection">
  <div id="bingc-active-date-selection-select-hour" class="bingc-active-date-selection-select-hour bingc-active-date-selection-select-hour-hover">
  <span id="bingc-active-date-selection-selected-hour" class="bingc-active-date-selection-selected-hour">10</span>
  <svg class="bingc-active-date-selection-arrows" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 14" enable-background="new 0 0 10 14" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99,8.905L4.995,13.9L0,8.905"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0,4.995L4.995,0L9.99,4.995"></path></svg>
  <div id="bingc-active-date-selection-select-hour-list-of-hours-container" class="bingc-active-date-selection-select-hour-list-of-hours-container two-columns"><ul class="bingc-active-date-selection-select-hour-list-of-hours "><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li></ul><ul class="bingc-active-date-selection-select-hour-list-of-hours second-column"><li>18</li></ul></div>
  </div>
  <div id="bingc-active-date-selection-select-minutes" class="bingc-active-date-selection-select-minutes bingc-active-date-selection-select-minutes-hover">
  <span id="bingc-active-date-selection-selected-minutes" class="bingc-active-date-selection-selected-minutes">00</span>
  <svg class="bingc-active-date-selection-arrows" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 14" enable-background="new 0 0 10 14" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99,8.905L4.995,13.9L0,8.905"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0,4.995L4.995,0L9.99,4.995"></path></svg>
  <div id="bingc-active-date-selection-select-minutes-list-of-minutes-container" class="bingc-active-date-selection-select-minutes-list-of-minutes-container">
  	<ul class="bingc-active-date-selection-select-minutes-list-of-minutes">
  		<li>00</li>
  		<li>15</li>
  		<li>30</li>
  		<li>45</li>
  	</ul>
  </div>
  </div>
  </div>
  <div class="bingc-active-get-phone-form-input-border bingc-offline-form"></div>
  <input type="tel" id="bingc-active-get-phone-form-input" class="bingc-active-get-phone-form-input" placeholder="Ваш номер телефона" value="" autocomplete="off" onfocus="this.value = this.value;"><a href="javascript:void(0);" id="bingc-active-phone-form-button" class="bingc-active-phone-form-button">Жду
  звонка</a></form>
  </div>
  <div id="bingc-phone-sample" class="bingc-phone-sample"><span>Например: 067 000 00 00</span></div>`;
     }
      setTimeout(function () {
         document.querySelector('.bingc-active-closed').classList.remove('bingc-active-closed');
     }, 500);
      console.clear();
  }, 2500); */

		if (window.counters !== undefined) {
			for (var i = 0; i < window.counters.length; i++) {
				window.counters[i]();
			}
		}
		window.onRoistatAllModulesLoaded = function () {
			setTimeout(function () {
				$('.js-promo-code').text(window.roistat.visit).addClass('promocode__number--is-load');
			}, 1000);
		};

		(function () {
			var $el = $('.js-lozad-force');
			if ($el.length) {
				$el.get().forEach(function (item) {
					window.lazyLoad.triggerLoad(item);
				});
			}
		})();

		/* (function () {
  	let $el = $('[data-auto-type="advice"]');
  		function getC () {
  		if (typeof Cookies.getJSON('advice') !== 'undefined') {
  			return Cookies.getJSON('advice');
  		} else {
  			return {state: false};
  		}
  	}
  		function setC (obj) {
  		Cookies.set('advice', obj, {expires: 365});
  	}
  		if (getC().state !== 'is-shown' && !Cookies.get('w-form')) {
  		$(document).on('mouseleave.advice', function (e) {
  			if (e.clientY <= 0) {
  				if (!Cookies.get('w-form') && !$.magnificPopup.instance.isOpen) {
  					$el.trigger('click');
  					setC({state: 'is-shown'});
  					$(document).off('.advice');
  				}
  			}
  		});
  	}
  }()); */

		(function () {
			var $el = $('.js-sales-funnel');
			if (!$el.length) return false;

			function getC() {
				if (typeof Cookies.getJSON('sales-funnel') !== 'undefined') {
					return Cookies.getJSON('sales-funnel');
				} else {
					return { state: false };
				}
			}

			function setC(obj) {
				Cookies.set('sales-funnel', obj, { expires: 7 });
			}

			if (getC().state !== 'is-shown' && !Cookies.get('w-form')) {
				// Добавил интервал, т.к. не красиво, когда я только открыл вкладку и буквально сразу тянусь вверх (может, чтобы просто переместить вкладку), а оно мне всплывайку показывает
				setTimeout(function () {
					$(document).on('mouseleave.sales-funnel', function (e) {
						if (e.clientY <= 0) {
							if (!Cookies.get('w-form') && !$.magnificPopup.instance.isOpen) {
								$el.trigger('click');
								setC({ state: 'is-shown' });
								$(document).off('.sales-funnel');

								var gtagString = 'gtag("event", "show-exit", {"event_category": "popup-funnel", "event_label": "", "value": ""})';
								if (window.gtag !== undefined) {
									window.gtag('event', 'show-exit', {
										'event_category': 'popup-funnel',
										'event_label': '',
										'value': ''
									});
									console.info('Выполнена строка = ' + gtagString);
								} else {
									console.error('Объект ga не определен! Строка НЕ выполнена = ' + gtagString);
								}
							}
						}
					});
				}, 10000);
			}
		})();

		(function () {
			var url = window.location.search;
			var $el = $('[data-auto-type="rating"]');
			var timeShow = +$el.data('time');

			function getC() {
				if (typeof Cookies.getJSON('rating') !== 'undefined') {
					return Cookies.getJSON('rating');
				} else {
					return { state: false, time: false };
				}
			}

			function setC(obj) {
				Cookies.set('rating', obj, { expires: 365 });
			}

			function showPopUp(time) {
				if (!$.magnificPopup.instance.isOpen) {
					setTimeout(function () {
						$el.trigger('click');
						setC({ state: 'is-shown' });
					}, time * 1000);
				}
			}

			if (getC().state !== 'is-shown') {
				if (url.indexOf('ratingruneta.ru') !== -1 && $el.length) {
					setC({ state: 'is-active', time: timeShow });
					showPopUp(timeShow);
				}

				if (getC().state === 'is-active') {
					showPopUp(getC().time);
				}
			}
		})();

		(function () {
			var hash = window.location.hash;
			var $el = $('.js-auto-play');
			if (hash === '#auto-play' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		})();

		(function () {
			var $el = $('.js-auto-click');
			if (!$el.length) return false;
			setTimeout(function () {
				$el.trigger('click');
			}, 100);
		})();

		(function () {
			var hash = window.location.hash;
			var $el = $('.js-working-day');
			if (hash === '#working-day' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		})();

		(function () {
			var hash = window.location.hash;
			var $el = $('.js-day-off');
			if (hash === '#day-off' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		})();

		(function () {
			var hash = window.location.hash;
			var $el = $('.js-preparing-offer');
			if (hash === '#preparing-offer' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		})();

		(function () {
			var hash = window.location.hash;
			var $el = $('.js-commercial-offer');
			if (hash === '#commercial-offer' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		})();

		(function () {
			var freeAccess = $('.js-free-access');
			var salesFunnel = $('.js-sales-funnel');
			if (!freeAccess.length || !salesFunnel.length) return false;

			var hasClick = false;
			var gtagString = 'gtag("event", "show-click", {"event_category": "popup-funnel", "event_label": "", "value": ""})';

			freeAccess.on('click', function () {
				salesFunnel.trigger('click');

				if (!hasClick) {
					hasClick = true;
					if (window.gtag !== undefined) {
						window.gtag('event', 'show-click', {
							'event_category': 'popup-funnel',
							'event_label': '',
							'value': ''
						});
						console.info('Выполнена строка = ' + gtagString);
					} else {
						console.error('Объект ga не определен! Строка НЕ выполнена = ' + gtagString);
					}
				}
			});
		})();

		/* (function () {
  	const POPUP_SALES_INTERVAL = 86400000; // частота показа всплывайки, в миллисекундах, 86400000 = 24 часа
  	const POPUP_SALES_DELAY = 1000 * 20; // через какое время, после загрузки страницы, отобразить всплывайку
  		setTimeout(function () {
  		let $salesFunnel = $('.js-sales-funnel');
  		if (!$salesFunnel.length) return false;
  			let popupSalesFunnelLastShow = parseFloat(window.localStorage.getItem('popupSalesFunnelLastShow')) || 1;
  		let dateNow = Date.now();
  			if ((popupSalesFunnelLastShow + POPUP_SALES_INTERVAL) > dateNow) return false; // рано по времени еще раз показывать
  		if ($.magnificPopup.instance.isOpen) return false; // сейчас открыта другая всплывайка
  			$salesFunnel.trigger('click');
  		window.localStorage.setItem('popupSalesFunnelLastShow', dateNow);
  	}, POPUP_SALES_DELAY);
  }()); */
	});
})(window.jQuery);

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Top Load
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	function startVideo() {
		var $this = $(this);
		var $video = $(this).find('video');
		var video = $video.get(0);

		if (typeof $video.attr('src') === 'undefined') {
			$video.attr('src', $video.data('src'));
		}

		video.play();
		video.controls = true;
		$this.removeClass('is-video-hide').addClass('is-play');

		video.addEventListener('ended', function () {
			resetVideo($this, video);
		});
	}

	function resetVideo($el, video) {
		$el.removeClass('is-play');
		video.controls = false;
	}

	$('.js-play-video').on('click', function () {
		startVideo.call(this);
	});

	$('.js-video').on('click', function (e) {
		e.stopPropagation();
		if (this.paused) {
			this.play();
		} else {
			this.pause();
		}
	});

	$('.js-hover-video').on('mouseenter', '.js-case-video', function () {
		var _this = this;
		var $this = $(_this);

		if (typeof $this.attr('src') === 'undefined') {
			$this.attr('src', $this.data('src'));
		}

		this.playbackRate = 0.7;
		this.play();
	}).on('mouseleave', '.js-case-video', function () {
		this.pause();
	});
})(window.jQuery);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	function withZero(time) {
		var nTime = time;
		if (time < 10) {
			nTime = '0' + time;
		}
		return nTime;
	}

	function correctTime(date) {
		var open = true;
		var h = date.getHours();
		var m = date.getMinutes();

		if (h < 9 || h > 18) {
			open = false;
		}

		return { text: withZero(h) + '<span class="dot-anim">:</span>' + withZero(m), opened: open };
	}

	function getTimeUTC() {
		var d = new Date();
		var utc = d.getTime() + d.getTimezoneOffset() * 60000;
		return utc;
	}

	function setTime(offset) {
		var date = new Date(getTimeUTC() + 3600000 * offset);
		return correctTime(date);
	}

	function renderTime() {
		$('.js-time').each(function (i) {
			var $this = $(this);
			var tz = $this.data('timezone');
			var time = setTime(tz);

			setTimeout(function () {
				$this.html(time.text);
				if (!time.opened) {
					$('.time-office', $this.closest('.grid')).addClass('_color-border');
				}
			}, 100 * i);
		});
	}
	renderTime();
	setInterval(renderTime, 5000);
})();

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Расширение библиотеки валидации
 * @module
 */

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Получение имени типа
 * @param {string} type
 * @return {string}
 * @private
 */

function formGetTypeName(type) {
	var typeName = void 0;
	switch (type) {
		case 'select-one':
		case 'select-multiple':
			typeName = '_select';
			break;
		case 'radio':
		case 'checkbox':
			typeName = '_checker';
			break;
		default:
			typeName = '';
	}
	return typeName;
}

/**
 * Получение сообщения в зависимости от элемента
 * @param {HTMLElement} element
 * @param {string} method
 * @return {string}
 * @private
 */
function formGetMethodMsgName(element, method) {
	var value = element.value;
	var methodName = void 0;
	switch (method) {
		case 'required':
		case 'maxlength':
		case 'minlength':
		case 'rangelength':
			methodName = method + formGetTypeName(element.type);
			break;
		case 'password':
			if (/^(\s|\t)*/.test(value)) {
				methodName = method + '_space';
			} else {
				methodName = method;
			}
			break;
		case 'url':
			if (!/((?!\/).)\..*$/.test(value)) {
				methodName = method + '_domen';
			} else if (!/\..{2,}$/.test(value)) {
				methodName = method + '_domen-length';
			} else {
				methodName = method;
			}
			break;
		case 'email':
			if (/(@\.|\.$)/.test(value)) {
				methodName = method + '_dot';
			} else if (/@.*(\\|\/)/.test(value)) {
				methodName = method + '_slash';
			} else if (!/@/.test(value)) {
				methodName = method + '_at';
			} else if (/^@/.test(value)) {
				methodName = method + '_at-start';
			} else if (value.split('@').length > 2) {
				methodName = method + '_at-multiple';
			} else if (/@$/.test(value)) {
				methodName = method + '_at-end';
			} else {
				methodName = method;
			}
			break;
		default:
			methodName = method;
	}
	return methodName;
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Объект расширений
 * @const {Object}
 */
var extendConfig = {
	/**
  * Прототипы плагина
  * @var {Object} messages
  * @sourceCode |+30
  */
	get messages() {
		var translates = window.jsTranslations && window.jsTranslations.validation || {};

		for (var key in translates) {
			var value = translates[key];

			switch (key) {
				case 'maxlength':
				case 'maxlength_checker':
				case 'maxlength_select':
				case 'minlength':
				case 'minlength_checker':
				case 'minlength_select':
				case 'rangelength':
				case 'rangelength_checker':
				case 'rangelength_select':
				case 'range':
				case 'min':
				case 'max':
				case 'filetype':
				case 'filesize':
				case 'filesizeEach':
				case 'pattern':
					translates[key] = $.validator.format(value);
					break;
			}
		}

		return translates;
	},

	/**
  * Прототипы плагина
  * @var {Object} prototype
  */
	prototype: {
		/**
   * Вывод дефолтных сообщений
   * @param {Element} element
   * @param {Object|string} rule
   * @return {string}
   * @method prototype::defaultMessage
   */
		defaultMessage: function defaultMessage(element, rule) {
			if (typeof rule === 'string') {
				rule = { method: rule };
			}

			var message = this.findDefined(this.customMessage(element.name, rule.method), this.customDataMessage(element, rule.method), !this.settings.ignoreTitle && element.title || undefined, // eslint-disable-line no-mixed-operators
			$.validator.messages[formGetMethodMsgName(element, rule.method)], '<strong>Warning: No message defined for ' + element.name + '</strong>');

			var pattern = /\$?\{(\d+)\}/g;

			if (typeof message === 'function') {
				message = message.call(this, rule.parameters, element);
			} else if (pattern.test(message)) {
				message = $.validator.format(message.replace(pattern, '{$1}'), rule.parameters);
			}

			return message;
		}
	},

	/**
  * Методы валидации
  * @var {Object} methods
  */
	methods: {
		/**
   * Валидация email
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::email
   * @sourceCode |+4
   */
		email: function email(value, element) {
			var pattern = /^(([a-zA-Z0-9&+-=_])+((\.([a-zA-Z0-9&+-=_]){1,})+)?){1,64}@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
			return this.optional(element) || pattern.test(value);
		},
		url: function url(value, element) {
			return this.optional(element) || /^((?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
		},


		/**
   * Валидация паролей
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::password
   * @sourceCode |+3
   */
		password: function password(value, element) {
			return this.optional(element) || /^\S.*$/.test(value);
		},


		/**
   * Проверка общего объема всех файла в KB
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::filesize
   * @sourceCode |+7
   */
		filesize: function filesize(value, element, param) {
			var kb = 0;
			for (var i = 0; i < element.files.length; i++) {
				kb += element.files[i].size;
			}
			return this.optional(element) || kb / 1024 <= param;
		},


		/**
   * Максимальное количество файлов для загрузки
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::maxupload
   * @sourceCode |+3
   */
		maxupload: function maxupload(value, element, param) {
			return element.files.length <= param;
		},


		/**
   * Проверка объема каждого файла в KB
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::filesizeeach
   * @sourceCode |+10
   */
		filesizeeach: function filesizeeach(value, element, param) {
			var flag = true;
			for (var i = 0; i < element.files.length; i++) {
				if (element.files[i].size / 1024 > param) {
					flag = false;
					break;
				}
			}
			return this.optional(element) || flag;
		},


		/**
   * Проверка типа файла по расширению
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::filetype
   * @sourceCode |+25
   */
		filetype: function filetype(value, element, param) {
			var result = void 0;
			var extensions = 'png|jpe?g|doc|pdf|gif|zip|rar|tar|html|swf|txt|xls|docx|xlsx|odt';
			if (element.files.length < 1) {
				return true;
			}

			param = typeof param === 'string' ? param.replace(/,/g, '|') : extensions;
			if (element.multiple) {
				var files = element.files;
				for (var i = 0; i < files.length; i++) {
					var _value = files[i].name;
					var valueMatch = _value.match(new RegExp('.(' + param + ')$', 'i'));

					result = this.optional(element) || valueMatch;
					if (result === null) {
						break;
					}
				}
			} else {
				var _valueMatch = value.match(new RegExp('\\.(' + param + ')$', 'i'));
				result = this.optional(element) || _valueMatch;
			}
			return result;
		},


		/**
   * Проверка валидности одного из указанных элементов
   * _этот или другой - должен быть валидным_
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::or
   * @sourceCode |+4
   */
		or: function or(value, element, param) {
			var $module = $(element).parents('.js-form');
			return $module.find(param + ':filled').length;
		},


		/**
   * Проверка валидности слов (чаще всего используется для имени или фамилии)
   * @param {string} value
   * @param {Element} element
   * @return {boolean}
   * @method methods::word
   * @sourceCode |+4
   */
		word: function word(value, element) {
			var testValue = /^[a-zA-Zа-яА-ЯіІїЇєёЁЄґҐĄąĆćĘęŁłŃńÓóŚśŹźŻż\'\`\- ]*$/.test(value); // eslint-disable-line no-useless-escape
			return this.optional(element) || testValue;
		},


		/**
   * Проверка валидности логинов
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::login
   * @sourceCode |+4
   */
		login: function login(value, element) {
			var testValue = /^[0-9a-zA-Zа-яА-ЯіІїЇєЄёЁґҐ][0-9a-zA-Zа-яА-ЯіІїЇєЄґҐĄąĆćĘęŁłŃńÓóŚśŹźŻż\-\._]+$/.test(value); // eslint-disable-line no-useless-escape
			return this.optional(element) || testValue;
		},


		/**
   * Валидация номера телефона (укр)
   * @param {string} value
   * @param {Element} element
   * @return {boolean}
   * @method methods::phoneua
   * @sourceCode |+3
   */
		phoneua: function phoneua(value, element) {
			return this.optional(element) || /^(((\+?)(38))\s?)?(([0-9]{3})|(\([0-9]{3}\)))(\-|\s)?(([0-9]{3})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{2})|([0-9]{2})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{3})|([0-9]{2})(\-|\s)?([0-9]{3})(\-|\s)?([0-9]{2}))$/.test(value); // eslint-disable-line no-useless-escape
		},


		/**
   * Валидация номера телефона (общая)
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::phone
   * @sourceCode |+3
   */
		// phone (value, element) {
		// 	return this.optional(element) || /^(((\+?)(\d{1,3}))\s?)?(([0-9]{0,4})|(\([0-9]{3}\)))(\-|\s)?(([0-9]{3})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{2})|([0-9]{2})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{3})|([0-9]{2})(\-|\s)?([0-9]{3})(\-|\s)?([0-9]{2}))$/.test(value); // eslint-disable-line no-useless-escape
		// },

		phone: function phone(value, element) {
			var placeholder = element.getAttribute('placeholder').replace(/[^0-9]/g, '');
			var val = value.replace(/[^0-9]/g, '');
			return val.length === placeholder.length;
		},


		/**
   * Проверки пробелов в значении
   * @param {string} value
   * @return {boolean}
   * @method methods::nospace
   * @sourceCode |+4
   */
		nospace: function nospace(value) {
			var str = value.replace(/\s|\t|\r|\n/g, '');
			return str.length > 0;
		},


		/**
   * Проверки валидности элемента
   * @param {string} value
   * @param {Element} element
   * @return {boolean}
   * @method methods::validTrue
   * @sourceCode |+3
   */
		validdata: function validdata(value, element) {
			return $(element).data('valid') === true;
		}
	}
};

for (var key in extendConfig) {
	$.extend($.validator[key], extendConfig[key]);
}

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Замена в элементе, в основном текстового, контента
 *  из его дата атрибутов.
 *
 * Удобно использовать при замене множества элементов,
 *  у которых должен свой свой индивидуальный текст,
 *  либо если этот текст зхависит от действий пользователя
 *
 * Пример - загрузка файлов. При смене инпута (file)
 *  можем узнать имя файла (если один)
 *  или их количество (при множественном выборе).
 *  Также мы можем узнать общий объем файлов и вывести все
 *  в удобный нам элемент, плюс простилизоват его.
 *
 *
 * @sourcecode jQueryExtends:changeMyText
 * @memberof   jQueryExtends
 * @requires   {@link wHelpers.replaceFromArray }
 * @param      {string}     [prop="default"] - Ключ свойтсва с которого нужно взять текст для замены
 * @param      {Array}      [replaceArray=[]] - Массив значений с которых следует сделать замену паттернов
 * @return     {undefined}
 */
$.fn.changeMyText = function (prop, replaceArray) {
	return this.each(function (index, el) {
		var $element = $(el);
		var textData = $element.data('text');

		if ((typeof textData === 'undefined' ? 'undefined' : _typeof(textData)) !== 'object') {
			console.warn($element, 'Не имеет данных с тектом -> data-text=\'{"key": "value"}\'');
			return true;
		}

		replaceArray = replaceArray || [];
		prop = prop || 'default';
		var value = textData[prop];

		if (typeof value !== 'string') {
			console.warn($element, 'Не имеет свойтва "' + prop + '"');
			return true;
		}

		if (replaceArray.length) {
			value = replaceFromArray(value, replaceArray);
		}

		$element.html(value);
	});
};

function replaceFromArray(replacingString, values, pattern) {
	pattern = pattern || '%s';
	if (!Array.isArray(values)) {
		values = [values];
	}

	for (var i = 0; i < values.length; i++) {
		var value = values[i];
		replacingString = replacingString.replace(pattern, value);
	}

	return replacingString;
}

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Простой прелодер
 * @module
 */

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Дофелтный конфиг для всех экземпляров
 * @type {Object}
 * @prop {string} mainClass - основной CSS класс, который добавляется к контейнеру прелодара
 * @prop {string} subClass - Дополнительный CSS класс - который будет добавлен, если имеет логически позитивное значение
 * @prop {string} showClass - CSS класс, который добавляется к контейнеру прелодара, при его показе
 * @prop {string} hideClass - CSS класс, который добавляется к контейнеру прелодара, перед его закрытием
 * @prop {number} removeDelay - время задержки, после которой будут удалены разметка прелоадре и CSS классы у контейнера
 * @prop {string} markup - Разметка прелодера
 * @private
 */

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultConfig = {
	mainClass: 'preloader',
	subClass: '',
	showClass: 'preloader--show',
	hideClass: 'preloader--hide',
	removeDelay: 200,
	markup: '<div class="preloader__block"></div>'
};

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Создание прелодаров
 * @param {jQuery} $container - контейнер для прелоадера
 * @param {Object} [userConfig={}] - Пользвательский конфиг для создваемого экземпляра
 * @prop {jQuery} [$container] - контейнер для прелоадера
 * @prop {jQuery} [$markup] - блок разметки прелоадера
 * @prop {Object|number} timer - id таймера
 */

var Preloader = function () {
	function Preloader($container) {
		var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, Preloader);

		this.$container = $container;
		this.config = $.extend({}, defaultConfig, userConfig);
		this.timer = null;
		this.$container.closest('form').data('preloader', this);
	}

	/**
  * Показ прелодера
  * @param {string} [place="append"] - append / prepend / before / after
  * @sourceCode
  */


	_createClass(Preloader, [{
		key: 'show',
		value: function show() {
			var _this = this;

			var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'append';
			var _config = this.config,
			    mainClass = _config.mainClass,
			    subClass = _config.subClass,
			    showClass = _config.showClass;

			this.$container.addClass(mainClass);
			if (subClass) {
				this.$container.addClass(subClass);
			}
			this.$markup = $(this.config.markup);
			this.$container[place](this.$markup);

			window.clearTimeout(this.timer);
			this.timer = window.setTimeout(function () {
				_this.$container.addClass(showClass);
				_this.$container.attr('disabled', true);
			}, 10);
		}

		/**
   * Скритие прелодера
   * @param {boolean} [removeMarkup=true] - удалить разметку прелодера после скрития
   * @sourceCode
   */

	}, {
		key: 'hide',
		value: function hide() {
			var _this2 = this;

			var removeMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
			var _config2 = this.config,
			    mainClass = _config2.mainClass,
			    subClass = _config2.subClass,
			    showClass = _config2.showClass,
			    hideClass = _config2.hideClass;

			this.$container.addClass(hideClass);
			window.clearTimeout(this.timer);
			this.timer = window.setTimeout(function () {
				if (removeMarkup) {
					_this2.$markup.remove();
				}
				_this2.$container.removeClass([mainClass, showClass, hideClass].join(' '));
				_this2.$container.removeAttr('disabled');
				if (subClass) {
					_this2.$container.removeClass(subClass);
				}
			}, this.config.removeDelay + 50);
		}

		/**
   * Получение глобального конфига для всех прелодаров
   * @returns {Object}
   * @sourceCode
   */

	}], [{
		key: 'config',
		get: function get() {
			return defaultConfig;
		}

		/**
   * Установка глобального конфига
   * @param {Object} value
   * @sourceCode
   */
		,
		set: function set(value) {
			$.extend(defaultConfig, value);
		}
	}]);

	return Preloader;
}();

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = Preloader;

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инициализация плагина Magnific Popup
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mfpWysiwyg = exports.mfpImage = exports.mfpIframe = exports.mfpAjax = undefined;

__webpack_require__(75);

var _merge = __webpack_require__(76);

var _merge2 = _interopRequireDefault(_merge);

var _validation = __webpack_require__(15);

var _validation2 = _interopRequireDefault(_validation);

var _horizontalScroll = __webpack_require__(21);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(22);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _phoneInput = __webpack_require__(39);

var _phoneInput2 = _interopRequireDefault(_phoneInput);

var _animate = __webpack_require__(13);

var _animate2 = _interopRequireDefault(_animate);

var _tabs = __webpack_require__(40);

var _tabs2 = _interopRequireDefault(_tabs);

var _swiper = __webpack_require__(42);

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

// переводы для плагина
(function ($) {
	var jsTranslations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var mfp = jsTranslations.mfp;

	if (!mfp) {
		return false;
	}

	$.extend(true, $.magnificPopup.defaults, {
		tClose: mfp.tClose,
		tLoading: mfp.tLoading,
		gallery: {
			tPrev: mfp.tPrev,
			tNext: mfp.tNext,
			tCounter: mfp.tCounter
		},
		image: {
			tError: mfp.tErrorImage
		},
		ajax: {
			tError: mfp.tError
		},
		inline: {
			tNotFound: mfp.tNotFound
		}
	});
})(window.jQuery, window.jsTranslations);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @param {jQuery} [$wrapper=$('body')] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function mfpAjax() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-ajax';
	var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var $wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $('body');

	var config = (0, _merge2.default)({
		mainClass: 'zoom-in',
		type: 'ajax',
		delegate: selector,
		removalDelay: 200,
		autoFocusLast: false,
		fixedContentPos: false,
		closeOnBgClick: false,
		callbacks: {
			elementParse: function elementParse(item) {
				var _item$el$data = item.el.data(),
				    url = _item$el$data.url,
				    _item$el$data$type = _item$el$data.type,
				    type = _item$el$data$type === undefined ? 'POST' : _item$el$data$type,
				    _item$el$data$param = _item$el$data.param,
				    data = _item$el$data$param === undefined ? {} : _item$el$data$param;

				this.st.ajax.settings = { url: url, type: type, data: data };
			},
			ajaxContentAdded: function ajaxContentAdded() {
				var _this = this;
				var $container = this.contentContainer || [];
				if ($container) {
					(0, _horizontalScroll2.default)('.wysiwyg table', $container);
					(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video', $container);
					(0, _validation2.default)('.js-form', $container);
					(0, _phoneInput2.default)($container);
					(0, _animate2.default)($container);
					(0, _tabs2.default)($container);
					(0, _swiper2.default)();
				}

				if (typeof this.currItem.el.data('order-name') !== 'undefined') {
					$container.find('.js-order-name').html(this.currItem.el.data('order-name'));
				}

				var setNumber = $('.js-set-number');

				$(".attachment__input").change(function () {
					var filename = $(this).val().replace(/.*\\/, "");
					if (!filename.length) {
						$(".attachmen__text").html('Add an attachment');
					} else {
						$(".attachmen__text").html(filename);
					}
				});

				if (setNumber.length) {
					var number = $('#get-number').text();
					setNumber.text(number);
					number = number.replace(/ /g, '');
					setNumber.attr('href', 'tel:+38' + number);
				}

				$(_this.wrap).on('mousedown', function (e) {
					_this.st.closeOnBgClick = true;
					if (_this._checkIfClose(e.target)) {
						_this.close();
					}
					_this.st.closeOnBgClick = false;
				});
			}
		}
	}, userConfig);

	$wrapper.magnificPopup(config);
}

function mfpIframe() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-iframe';
	var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var config = (0, _merge2.default)({
		mainClass: 'zoom-in',
		type: 'iframe',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200,
		iframe: {
			markup: '<div class="magnific-popup mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1&showinfo=0'
				}
			}
		}
	}, userConfig);

	$(selector).magnificPopup(config);
}

function mfpImage() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-image';
	var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var config = (0, _merge2.default)({
		mainClass: 'zoom-in',
		type: 'image',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200
	}, userConfig);

	$(selector).magnificPopup(config);
}

function mfpWysiwyg() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.wysiwyg';
	var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var config = (0, _merge2.default)({
		mainClass: 'zoom-in',
		type: 'image',
		delegate: '[target="_mfp"]',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200
	}, userConfig);

	$(selector).magnificPopup(config);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.mfpAjax = mfpAjax;
exports.mfpIframe = mfpIframe;
exports.mfpImage = mfpImage;
exports.mfpWysiwyg = mfpWysiwyg;

/***/ })

},[45]);


// WEBPACK FOOTER //
// initialize.js